import styled from "styled-components";

export const SidebarTopPatients = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 0.9rem;
`;

export const ToggleContainer = styled.div`
  height: 26px;
  margin-bottom: 10px;
`;

export const FilterContainer = styled.div`
  margin: 0 5px 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .button-create-chat-group {
    background-color: #f0f0ff;
    border-radius: 38px;
    padding: 10px;
    font-size: 14px;
    color: #36369b;
  }
`;

export const InputContainer = styled.div`
  margin: 0 5px;
`;
export const TitleContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  color: var(--blue-color);
  font-family: "Nunito Sans ExtraBold";
  align-items: center;

  span {
    font-family: "Nunito Semibold";
    font-size: 17px;
  }
`;
